(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/footer/footer.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/footer/footer.js');
"use strict";

const showTermsDialog = svs.ticket_partner.utils.showTermsDialog;
const Symbols = svs.ui.ReactSymbols;
const _svs$ticket_partner$c = svs.ticket_partner.constants.copy.FOOTER,
  TERMS_AND_CONDITIONS_TEXT = _svs$ticket_partner$c.TERMS_AND_CONDITIONS_TEXT,
  LINK_TEXT = _svs$ticket_partner$c.LINK_TEXT,
  AGE_TEXT = _svs$ticket_partner$c.AGE_TEXT;
const Footer = () => {
  const handleOnClick = e => {
    e.preventDefault();
    showTermsDialog();
  };
  return React.createElement("div", {
    className: "footer-bottom"
  }, React.createElement("div", {
    className: "margin-bottom-1"
  }, React.createElement(Symbols, {
    height: 56,
    name: "18-logo-pos"
  })), React.createElement("div", null, React.createElement("p", null, AGE_TEXT), React.createElement("p", null, TERMS_AND_CONDITIONS_TEXT, React.createElement("a", {
    onClick: handleOnClick
  }, LINK_TEXT))));
};
svs.ticket_partner.sharedComponents.footer.Footer = Footer;

 })(window);